module.exports = __webpack_public_path__ + "images/img-3WMn6WW.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks/2.png
// module id = 1759
// module chunks = 0